export default __webpack_public_path__ + "static/pharma-marker-95b8a85b289da4865dfcc125914e86e5.png";